export default {
  titles: {
    subscription: {
      en: '{size}-month gift',
    },
    card: {
      en: 'Gift card',
    },
  },
  discount: {
    en: 'Save ${discount}',
  },
  hint: {
    en: 'Free shipping',
  },
  bestseller: {
    en: 'bestseller',
  },
  buttonTitle: {
    en: 'Order now',
  },
  selectedButtonTitle: {
    en: 'Your plan',
  },
}
